<template>
  <div id="ag-grid-demo">
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">
        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="fetchData(1, 20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="fetchData(1, 50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="fetchData(1, 100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="fetchData(1, 150)">
                <span>150</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="fetchData(1, totalData)">
                <span>Show All</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <!-- <vs-input
            class="mb-4 md:mb-0 mr-4"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Search..."
          />-->
          <vs-button class="mb-4 md:mb-0 mr-4" icon="add" :to="'/device/request/update'">Add Request</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dataTrx"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="limit"
        :suppressPaginationPanel="true"
        :enableCellTextSelection="true"
      ></ag-grid-vue>
      <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionTableAgGridComponent from "@/components/cell-render-component/ConfigDetailTableAgGridComponent";

export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Request Code",
          field: "code",
          filter: true,
          editable: false,
          width: 300,
          pinned: "left"
        },
        // {
        //   headerName: "Merchant Name",
        //   field: "merchants.full_name",
        //   width: 300,
        //   filter: true
        // },
        {
          headerName: "Device Type",
          field: "device_type.name",
          filter: true,
          editable: false,
          width: 200
        },
        {
          headerName: "Description",
          field: "notes",
          filter: true,
          editable: false,
          width: 250
        },
        {
          headerName: "Quantity",
          field: "device_qty",
          filter: true,
          editable: false,
          width: 150
        },
        {
          headerName: "Expected Date",
          field: "expected_date_f",
          filter: true,
          editable: false,
          width: 300
        },
        {
          headerName: "Status",
          field: "status",
          cellRendererFramework:ActionTableAgGridComponent,
          editable:false,
          filter: true,
          width: 300
        },
        {
          headerName: "Actions",
          field: "id",
          editable:false,
          filter: false,
          cellRendererParams:{isDetail:true, isConfigure:false, isCancel:true},
          cellRendererFramework: ActionTableAgGridComponent,
          width: 300
        }
      ],
      dataTrx: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      totalData: 1,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("Channel", null);
      } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
    }
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      }
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "default"
      });
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetchData(page, limit) {
      let newPage = page;
      if (this.dataCount != 0) {
        let totalPages = Math.ceil(this.dataCount / limit);
        if (page > totalPages) {
          newPage = totalPages;
        }
      }
      let merchant_filter = "";
      try {
        let merchantInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (merchantInfo.id !== undefined) {
          merchant_filter = "&merchant_id=" + merchantInfo.id;
        }
      } catch (e) {
        e;
      }
      this.openLoading()
      Axios.Get(
        url.svd.device_request.list +
          "?page=" +
          newPage +
          "&limit=" +
          limit +
          merchant_filter
      )
        .then(resp => {
          this.dataTrx = [];
          this.$vs.loading.close()
          if (resp.data.data.length != 0) {
            this.totalData = parseInt(resp.data.total)
            let no = 1;
            for (let data of resp.data.data) {
              data.no = no;
              this.dataTrx.push(data);
              no++;
            }

            this.dataCount = resp.data.total;
            this.page = page;
            if (limit >= this.dataCount) {
              this.limit = this.dataTrx.length;
            } else {
              this.limit = limit;
            }

            this.gridApi.paginationSetPageSize(this.limit);
            this.totalPage = resp.data.lastPage;
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          console.log(e);
        });
    },
    editRecord(value) {
      this.$router.push({
        name: "issuerMidEdit",
        params: {
          id: value
        }
      });
    },
    detailRecord(value){
      this.$router.push({'path':'/device/request/detail', query:{id:value}})
    },
    cancelRecord(value){
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: "Are you sure cancel this record ?",
        accept: () => {
          this.openLoading()
          let user_action = JSON.parse(localStorage.getItem("userInfo")).displayName
          Axios.Put(url.svd.device_request.update+"/"+value, {status:'cancel', user_action:user_action}).then(response =>{
            this.$vs.loading.close()
            if (response.data === 1) {

              this.fetchData(this.page, this.limit);
              this.$vs.notify({
                title: "Success",
                text: "You successfully cancel record !",
                iconPack: "feather",
                icon: "icon-check-square",
                color: "success",
                position: "top-right"
              });
            }else{

              this.fetchData(this.page, this.limit);
              this.$vs.notify({
                title: "Warning",
                text: "You fail cancel record !",
                iconPack: "feather",
                icon: "icon-check-square",
                color: "warning",
                position: "top-right"
              });
            }
          }).catch(e => {
            this.$vs.loading.close()
            console.log(e);
            this.$vs.notify({
              title: "Failed",
              text: "Network failed!",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right"
            });
          });
        }
      });
    },
    deleteRecord(data) {
      let root = this;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: "Are you sure deleted this record ?",
        accept: () => {
          Axios.Delete(url.svd.merchant.account_info + "/" + data)
            .then(resp => {
              if (resp.data === 1) {
                root.fetchData(root.page, root.limit);
                this.$vs.notify({
                  title: "Success",
                  text: "You successfully deleted Issuer MID!",
                  iconPack: "feather",
                  icon: "icon-check-square",
                  color: "success",
                  position: "top-right"
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.$vs.notify({
                title: "Failed",
                text: "Network failed!",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-right"
              });
            });
        }
      });
    }
  },
  mounted() {
    if (this.status) {
      this.$vs.notify({
        title: "Add device request",
        text: "Add device request success",
        color: "success",
        position: "top-right"
      });
    }
    this.gridApi = this.gridOptions.api;
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: '#f9f9f9' }
      }
    }
    this.gridOptions.rowHeight = 42;

    this.$root.$on("delete-from-ActionTableAgGridComponent", data => {
      this.deleteRecord(data);
    });

    this.$root.$on("cancel-from-ActionTableAgGridComponent", data => {
      this.cancelRecord(data);
    });

    this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
      this.editRecord(data);
    });

    this.$root.$on("detail-from-ActionTableAgGridComponent", data => {
      this.detailRecord(data);
    });

  },
  props: {
    status: {
      type: Boolean
    }
  }
};
</script>